export default __webpack_public_path__ + "static/media/Overcoming the obstacles.4a9276db.png";